module.exports = __webpack_public_path__ + "static/img_emergency_process_03@2x-d7c49e75429ed2c79db4a2991e2160a7.png";